import { refreshVisibleQuestionGroupStatuses } from './CheckValidationsOnInput';

export default function(inputGroup, suggestion = null) {
  let dependentQuestions = inputGroup.attr('data-dependent-questions');
  let dependentContents = inputGroup.attr('data-dependent-contents');
  let dependentSections = inputGroup.attr('data-dependent-sections');
  let dependentQuestionGroups = inputGroup.attr('data-dependent-question-groups');
  let dependentTables = inputGroup.attr('data-dependent-tables');

  if (
    (typeof dependentQuestions === 'undefined') && 
    (typeof dependentContents === 'undefined') &&
    (typeof dependentSections === 'undefined') &&
    (typeof dependentQuestionGroups === 'undefined') &&
    (typeof dependentTables === 'undefined') 
  ) {return}

  dependentQuestions = JSON.parse(dependentQuestions);

  // Add suggestion to arrays for comparison
  if (suggestion !== null) {
    $.each(dependentQuestions, function(i,arr) {
      dependentQuestions[i].push(suggestion);
    })
  }

  // Add dependencies from others tied to same question
  $('.input-group').filter(function() {
    let c = $(this).attr('data-determining-questions');
    if (typeof c === 'undefined') {
      return false
    } else {
      return c.includes('[' + dependentQuestions[0][0] + ',');
    }
  }).each(function() {
    let ic = $(this).attr('data-determining-questions');
    let val = $(this).find('.answer-text.tt-input').val();
    ic = JSON.parse(ic);
    ic[0].push(val);
    dependentQuestions.push(ic[0]);
  })

  // Hide or unhide rows from dependent questions
  if (typeof dependentQuestions !== 'undefined') {
    let matchesCriteria = {};
    $.each(dependentQuestions, function(i, arr) {
      matchesCriteria[arr[0]] = 0;
    });
    $.each(dependentQuestions, function(i, arr) {
      let dependentQuestion = arr[0];
      let displayVal = arr[1];
      let selectedVal = arr[2];

      // Add match if selected val is in the list of accepted answers
      if (selectedVal && selectedVal.trim() !== '') {
        // Split selectedVal on '|' if present, otherwise treat as single value
        let selectedVals = selectedVal.split('|').map(function(v) { return v.trim(); });
        // If any selected value matches an accepted answer, increment
        if (selectedVals.some(function(val) { return String(displayVal).indexOf(String(val)) !== -1; })) {
          matchesCriteria[dependentQuestion]++;
        }
      }

      // Hide or unhide row, depending on whether there's a match with criteria
      let dependentRow = $('.question-row[data-question-id=' + dependentQuestion + ']');
      if (matchesCriteria[dependentQuestion] > 0) {
        dependentRow.removeClass('d-none');
      } else {
        dependentRow.addClass('d-none');
      }
    });
  }

  // Hide or unhide dependent question groups
  if (typeof dependentQuestionGroups !== 'undefined') {
    let matchesCriteria = {};
    dependentQuestionGroups = JSON.parse(dependentQuestionGroups);
    $.each(dependentQuestionGroups, function(i, arr) {
      matchesCriteria[arr[0]] = 0;
    });
    $.each(dependentQuestionGroups, function(i, arr) {
      let dependentQuestionGroup = arr[0];
      let displayVal = arr[1];
      let selectedVal = suggestion;

      // Add match if selected val is in the list of accepted answers
      if (selectedVal && selectedVal.trim() !== '') {
        // Split selectedVal on '|' if present, otherwise treat as single value
        let selectedVals = selectedVal.split('|').map(function(v) { return v.trim(); });
        // If any selected value matches an accepted answer, increment
        if (selectedVals.some(function(val) { return String(displayVal).indexOf(String(val)) !== -1; })) {
          matchesCriteria[dependentQuestionGroup]++;
        }
      }

      // Hide or unhide row, depending on whether there's a match with criteria
      let dependentCard = $('.card[data-question-group-id=' + dependentQuestionGroup + ']');
      if (matchesCriteria[dependentQuestionGroup] > 0) {
        dependentCard.removeClass('d-none');
      } else {
        dependentCard.addClass('d-none');
      }
    });
  }

  // Hide or unhide dependent sections
  if (typeof dependentSections !== 'undefined') {
    let matchesCriteria = {};
    dependentSections = JSON.parse(dependentSections);
    $.each(dependentSections, function(i, arr) {
      matchesCriteria[arr[0]] = 0;
    });
    $.each(dependentSections, function(i, arr) {
      let dependentSection = arr[0];
      let displayVal = arr[1];
      let selectedVal = suggestion;

      // Add match if selected val is in the list of accepted answers
      if (selectedVal && selectedVal.trim() !== '') {

        // Split selectedVal on '|' if present, otherwise treat as single value
        let selectedVals = selectedVal.split('|').map(function(v) { return v.trim(); });

        // If any selected value matches an accepted answer, increment
        if (selectedVals.some(function(val) { return String(displayVal).indexOf(String(val)) !== -1; })) {
          matchesCriteria[dependentSection]++;
        }
      }

      // Hide or unhide row, depending on whether there's a match with criteria
      let dependentDiv = $('.survey-section[data-section-id=' + dependentSection + ']');
      if (matchesCriteria[dependentSection] > 0) {
        dependentDiv.removeClass('d-none');
      } else {
        dependentDiv.addClass('d-none');
      }
    });
  }

  // Hide or unhide dependent tables
  if (typeof dependentTables !== 'undefined') {
    let matchesCriteria = {};
    dependentTables = JSON.parse(dependentTables);
    $.each(dependentTables, function(i, arr) {
      matchesCriteria[arr[0]] = 0;
    });
    $.each(dependentTables, function(i, arr) {
      let dependentTable = arr[0];
      let displayVal = arr[1];
      let selectedVal = suggestion;

      // Add match if selected val is in the list of accepted answers
      if (selectedVal && selectedVal.trim() !== '') {
        // Split selectedVal on '|' if present, otherwise treat as single value
        let selectedVals = selectedVal.split('|').map(function(v) { return v.trim(); });
        // If any selected value matches an accepted answer, increment
        if (selectedVals.some(function(val) { return String(displayVal).indexOf(String(val)) !== -1; })) {
          matchesCriteria[dependentTable]++;
        }
      }

      // Hide or unhide the question-row parent of the table, depending on whether there's a match with criteria
      let dependentTableDiv = $('.question-row[data-table-id=' + dependentTable + ']');
      if (matchesCriteria[dependentTable] > 0) {
        dependentTableDiv.removeClass('d-none');
      } else {
        dependentTableDiv.addClass('d-none');
      }
    });
  }

  // Hide or unhide dependent contents
  if (typeof dependentContents !== 'undefined') {
    let matchesCriteria = {};
    dependentContents = JSON.parse(dependentContents);
    $.each(dependentContents, function(i, arr) {
      matchesCriteria[arr[0]] = 0;
    });
    $.each(dependentContents, function(i, arr) {
      let dependentContent = arr[0];
      let displayVal = arr[1];
      let selectedVal = suggestion;

      // Add match if selected val is in the list of accepted answers
      if (selectedVal && selectedVal.trim() !== '') {
        // Split selectedVal on '|' if present, otherwise treat as single value
        let selectedVals = selectedVal.split('|').map(function(v) { return v.trim(); });
        // If any selected value matches an accepted answer, increment
        if (selectedVals.some(function(val) { return String(displayVal).indexOf(String(val)) !== -1; })) {
          matchesCriteria[dependentContent]++;
        }
      }

      // Hide or unhide the question-row parent of the table, depending on whether there's a match with criteria
      let dependentContentDiv = $('.question-row[data-content-id=' + dependentContent + ']');
      if (matchesCriteria[dependentContent] > 0) {
        dependentContentDiv.removeClass('d-none');
      } else {
        dependentContentDiv.addClass('d-none');
      }
    });
  }

  refreshVisibleQuestionGroupStatuses();

}